var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentBetSlipState <= 1 ||
    _vm.parlayStake ||
    _vm.singlesStakes.length
    ? _c(
        "div",
        [
          _vm.brandTemplate === "generic_2" && _vm.tab === "REGULAR"
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !(
                        _vm.currentBetSlipState == 5 &&
                        _vm.betSlipStatus.State == 2
                      ),
                      expression:
                        "!(currentBetSlipState==5 && betSlipStatus.State==2)"
                    }
                  ],
                  staticClass: "PARLAY"
                },
                [
                  _vm.activeSelectionsNo > 1 && _vm.allowedBetTypesAndReturnsA
                    ? _c(
                        "div",
                        [
                          _vm.currentBetSlipState <= 1 || _vm.parlayStake
                            ? _c("bet-type-parlay", {
                                key: "A",
                                attrs: {
                                  id: "A",
                                  currentBetSlipState: _vm.currentBetSlipState,
                                  tab: _vm.tab,
                                  allowedBetTypesAndReturns:
                                    _vm.allowedBetTypesAndReturnsA,
                                  gettingABTnR: _vm.gettingABTnR
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeSelectionsNo > 1 &&
                  _vm.showParlayInfoMsg &&
                  _vm.currentBetSlipState <= 1 &&
                  !_vm.allowedBetTypesAndReturnsA &&
                  (!_vm.isSGMenabled || (_vm.isSGMenabled && !_vm.hasSGM))
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "msg info all_corners NoParlayAvailable",
                            class: {
                              interRelated: _vm.hasActiveInteRelated,
                              NotAllSelectionsCombinableInParlay: !_vm.allSelectionsCombinableInParlay
                            }
                          },
                          [
                            _c("v-icon", [_vm._v("info_outline")]),
                            _vm._v(" "),
                            _vm.hasActiveInteRelated &&
                            _vm.allSelectionsCombinableInParlay
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "BetSlip.tab.PARLAY.info.interRelated"
                                      )
                                    )
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "BetSlip.tab.PARLAY.info.notAvailable"
                                      )
                                    )
                                  )
                                ])
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.wagerAllSingles
            ? _c(
                "v-expansion-panel",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.tab === "REGULAR" &&
                        _vm.betsNo > 1 &&
                        _vm.currentBetSlipState < 1,
                      expression:
                        "tab==='REGULAR' && betsNo>1 && currentBetSlipState<1"
                    }
                  ],
                  staticClass: "stakeAll_holder"
                },
                [
                  _c(
                    "v-expansion-panel-content",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c("span", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t(
                                          "BetSlip.single.wagerAllStraights"
                                        )
                                      ) +
                                      "\n        "
                                  )
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        4071876568
                      )
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "stakeAll" },
                        [
                          _c("money-input", {
                            attrs: {
                              id: 1,
                              placeholder: "",
                              disabled: _vm.currentBetSlipState >= 1,
                              focus: _vm.focus
                            },
                            on: {
                              setFocus: _vm.setFocus,
                              dismissError: _vm.dismissError
                            },
                            model: {
                              value: _vm.multiSinglesStake,
                              callback: function($$v) {
                                _vm.multiSinglesStake = $$v
                              },
                              expression: "multiSinglesStake"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.currentBetSlipState && _vm.tab == "REGULAR"
            ? _c("div", { staticClass: "tab-btns" }, [
                _vm.hasAvailableTeasers
                  ? _c(
                      "button",
                      {
                        staticClass: "btn secondary btn_blue",
                        on: {
                          click: function($event) {
                            return _vm.setTab("TEASER")
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("BetSlip.tab.TEASERS")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "arrow-right" })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.currentBetSlipState &&
                _vm.tab == "REGULAR" &&
                _vm.hasAllowedBetTypesRR
                  ? _c(
                      "button",
                      {
                        staticClass: "btn secondary btn_blue",
                        on: {
                          click: function($event) {
                            return _vm.setTab("RR")
                          }
                        }
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.$t("BetSlip.tab.RRS")))]),
                        _vm._v(" "),
                        _c("span", { staticClass: "arrow-right" })
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c840bba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c840bba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/rootElements/tabsBetslipBottom.vue
// module id = null
// module chunks = 